import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CallSignClass;
function CallSign() {
  if (CallSignClass === VOID) {
    class $ {
      constructor(adjective, noun) {
        this.adjective_1 = adjective;
        this.noun_1 = noun;
      }
      toString() {
        return this.adjective_1 + ' ' + this.noun_1;
      }
      hashCode() {
        var result = getStringHashCode(this.adjective_1);
        result = imul(result, 31) + getStringHashCode(this.noun_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CallSign()))
          return false;
        if (!(this.adjective_1 === other.adjective_1))
          return false;
        if (!(this.noun_1 === other.noun_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CallSign');
    CallSignClass = $;
  }
  return CallSignClass;
}
//region block: exports
export {
  CallSign as CallSign1tjdkp2izdbad,
};
//endregion

//# sourceMappingURL=CallSign.mjs.map
